import { PropsWithChildren } from 'react';

const BasePageTemplate = ({ children }: PropsWithChildren) => <div className="flex min-h-screen flex-col">{children}</div>;

export default BasePageTemplate;
